if ( typeof ProductImageZoom !== 'function' ) {
	class ProductImageZoom extends HTMLElement {

		constructor(){

			super();

			if ( ! document.getElementById('zoom') ) {
				this.zoom = document.createElement('div');
				this.zoom.id = 'zoom';
				this.zoom.innerHTML = `
					<img />
					<span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>
					<span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
					<div class="zoom__overlay"></div>
				`;
				document.body.append(this.zoom);
				const exitBtn = this.zoom.querySelector('.zoom__exit');
				exitBtn.setAttribute('tabindex', '0');
				exitBtn.setAttribute('role', 'button');
				exitBtn.setAttribute('aria-label', 'Close zoom');
				exitBtn.addEventListener('click', this._productZoomUnmount.bind(this));
				exitBtn.addEventListener('keydown', (e) => {
					if ( e.key === 'Enter' ) this._productZoomUnmount();
				});
			} else {
				this.zoom = document.getElementById('zoom');
			}

			this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this);
			this.onResizeHandlerBinded = this.onResizeHandler.bind(this);
			this.onWheelHandlerBinded = this.onWheelHandler.bind(this);
			this.onKeyDownHandlerBinded = this.onKeyDownHandler.bind(this);

			const openZoom = () => {
				this.zoom.classList.add('opened');
				this.image = this.zoom.querySelector('img');
				this.image.src = this.getAttribute('data-image');
				if ( this.image.naturalWidth > 0 ) {
					this._productZoomMount();
				} else {
					this.image.addEventListener('load', this._productZoomMount.bind(this));
				}
			};

			this.addEventListener('click', openZoom);

			this.addEventListener('keydown', (e) => {
				if ( e.key === 'Enter' ) openZoom();
			});

		}

		onMouseMoveHandler(e){
			window.clientX = e.clientX;
			window.clientY = e.clientY;
			const x = e.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = e.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;
			this.image.style.left = x + 'px';
			this.image.style.top = y + 'px';
		}

		onResizeHandler(){

			const rf = window.innerWidth > 768 ? 1 : 2;

			if ( this.image.classList.contains('portrait') ) {
				this.image.style.width = ( window.innerWidth*rf ) + 'px';
				this.image.style.height = ( window.innerWidth*rf / this.image.dataset.ratio ) + 'px';
			} else {

				this.image.style.height = ( window.innerHeight*rf ) + 'px';
				this.image.style.width = ( window.innerHeight*rf * this.image.dataset.ratio ) + 'px';

				if ( this.image.offsetWidth < window.innerWidth ) {
					this.image.style.width = ( window.innerWidth*rf ) + 'px';
					this.image.style.height = ( window.innerWidth*rf / this.image.dataset.ratio ) + 'px';
				}

			}

			const x = window.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = window.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;

		}

		onKeyDownHandler(e) {
			const keys = ['ArrowUp','ArrowDown','ArrowLeft','ArrowRight'];
			if ( !keys.includes(e.key) ) return;
			e.preventDefault();
			const step = 80;
			const isTouch = document.body.classList.contains('touch') || document.body.classList.contains('touchevents');
			if ( isTouch ) {
				if ( e.key === 'ArrowLeft' )  this.zoom.scrollLeft -= step;
				if ( e.key === 'ArrowRight' ) this.zoom.scrollLeft += step;
				if ( e.key === 'ArrowUp' )    this.zoom.scrollTop  -= step;
				if ( e.key === 'ArrowDown' )  this.zoom.scrollTop  += step;
			} else {
				const minX = window.innerWidth - this.image.offsetWidth;
				const minY = window.innerHeight - this.image.offsetHeight;
				let x = parseFloat(this.image.style.left) || 0;
				let y = parseFloat(this.image.style.top)  || 0;
				if ( e.key === 'ArrowLeft' )  x = Math.min(0,    x + step);
				if ( e.key === 'ArrowRight' ) x = Math.max(minX, x - step);
				if ( e.key === 'ArrowUp' )    y = Math.min(0,    y + step);
				if ( e.key === 'ArrowDown' )  y = Math.max(minY, y - step);
				this.image.style.left = x + 'px';
				this.image.style.top  = y + 'px';
			}
		}

		onWheelHandler(e) {
			e.preventDefault();
			let dx = e.deltaX;
			let dy = e.deltaY;
			if ( e.deltaMode === 1 ) { dx *= 16; dy *= 16; }       // line mode
			else if ( e.deltaMode === 2 ) { dx *= window.innerWidth; dy *= window.innerHeight; } // page mode
			const minX = window.innerWidth - this.image.offsetWidth;
			const minY = window.innerHeight - this.image.offsetHeight;
			const x = Math.max(minX, Math.min(0, (parseFloat(this.image.style.left) || 0) - dx));
			const y = Math.max(minY, Math.min(0, (parseFloat(this.image.style.top) || 0) - dy));
			this.image.style.left = x + 'px';
			this.image.style.top = y + 'px';
		}


		_productZoomMount(image) {

			this.image.style.left = 0;
			this.image.style.top = 0;

			window.addEventListener('mousemove', this.onMouseMoveHandlerBinded, {passive:true});
			this.zoom.addEventListener('wheel', this.onWheelHandlerBinded, {passive:false});
			window.addEventListener('keydown', this.onKeyDownHandlerBinded);

			this.image.dataset.ratio = this.image.naturalWidth / this.image.naturalHeight;
			window.addEventListener('resize', this.onResizeHandlerBinded, {passive:true});
			this.onResizeHandler();

			setTimeout(()=>{
				if ( document.body.classList.contains('touch') || document.body.classList.contains('touchevents') ) {
					this.zoom.scrollTop = ( window.innerHeight - this.image.offsetHeight ) / -2;
					this.zoom.scrollLeft = ( window.innerWidth - this.image.offsetWidth ) / -2;
				}
				this.zoom.classList.add('loaded');
				this.zoom.querySelector('.zoom__exit').focus();  
			}, 50);

		}

		_productZoomUnmount() {

			this.zoom.classList.remove('opened');

			setTimeout(()=>{
				window.removeEventListener('resize', this.onResizeHandlerBinded);
				window.removeEventListener('mousemove', this.onMouseMoveHandlerBinded);
				this.zoom.removeEventListener('wheel', this.onWheelHandlerBinded);
				window.removeEventListener('keydown', this.onKeyDownHandlerBinded);
				const image = document.querySelector('#zoom img');
				image.src = '';
				image.className = '';
				image.style = '';
				this.zoom.classList.remove('loaded');
			}, 300);

		}

	}

  if ( typeof customElements.get('product-image-zoom') == 'undefined' ) {
		customElements.define('product-image-zoom', ProductImageZoom);
	}

}